import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactQuill from "react-quill";
import "./../../assets/quill.css";
import { gAPI_THREAD_SUMMARY, gAPI_AZURE_THREAD_DYNAMIC_SUMMARY, gAPI_THREAD_DYNAMIC_SUMMARY, pAPI_EMAIL_LOGS, putAPI_EMAIL_LOGS } from "../../constants/api";
import loader from "../../assets/images/plugin_loader.gif";
import CopyToClipboard from "react-copy-to-clipboard";
import Languages from "../../constants/languages";
import moment from "moment";
import axios from "axios";
import Rooms from "./Rooms";
import Rates from "./Rates";
import IntlMessage from "../helpers/IntlMessages";
const quillModules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};
const quillFormats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];
const Reply = ({
  pid,
  gid,
  cid,
  handleManage,
  userLang,
  emailLang,
  mailStatsChange,
  threadResponse,
  emailIntegration,
  questionSetDetails,
  propertyDetails,
  initialReply,
}) => {
  const quillRef = useRef(null);
  const [reply, setReply] = useState("");
  const [lang, setLang] = useState(emailLang || "en");
  const [showModal, setShowModal] = useState(false);
  const [formatedText, setFormatedText] = useState("");
  const [showRateModal, setShowRateModal] = useState(false);
  const [source, setSource] = useState();
  const [logId, setLogId] = useState(0);
  const [logContent, setLogContent] = useState([]);
  const [functionArguments, setFunctionArguments] = useState(
    threadResponse
      ? {
        checkInDate: moment(threadResponse?.check_in_date).format("YYYY-MM-DD"),
        checkOutDate: moment(threadResponse?.check_out_date).format("YYYY-MM-DD"),
        promoCode: threadResponse?.promo_code || threadResponse?.corporate_code || threadResponse?.group_code || "",
      }
      : {
        checkInDate: moment().add("days", 1).format("YYYY-MM-DD"),
        checkOutDate: moment().add("days", 2).format("YYYY-MM-DD"),
        promoCode: threadResponse?.promo_code || threadResponse?.corporate_code || threadResponse?.group_code || "",
      }
  );
  const [propertyIntegration, setPropertyIntegration] = useState(emailIntegration);
  const [additionalInstructions, setAdditionalInstructions] = useState("");
  const handleTranslation = () => {
    setReply("");
    if (lang === emailLang) setLang(userLang);
    else setLang(emailLang);
  };
  const convertMarkdownLinksToHtml = (text = "") => {
    return text.replace(
      /\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g,
      (_, label, url) =>
        `🔗 <a href="${url}" target="_blank" rel="noopener noreferrer">${label || url
        }</a>`
    );
  };

  useEffect(() => {
    if (initialReply !== undefined && initialReply !== null && initialReply !== "") {
      setReply(
        convertMarkdownLinksToHtml(initialReply)
      );
    } else {
      handleReload(true);
    }
  }, [lang]);

  const handleManageStats = (contentData) => {
    console.log("handleManageStats", emailIntegration?.channelDetails?.isReceivingEmail);
    if (emailIntegration?.channelDetails?.isReceivingEmail === true) {
      let lst = [...logContent, ...contentData];
      setLogContent(lst);
      let replyText = reply ?? "";
      setReply("");
      if (logId > 0) {
        fetch(`${putAPI_EMAIL_LOGS}`, {
          method: "Post",
          mode: "cors",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: logId,
            action: "Regenerate Reply with additional instructions",
            content: lst,
            isEmailLogs: true,
          }),
        })
          .then((res) => res.json()).then((result) => {
            setLogContent((content) => [...content, ...contentData]);
          })
          .catch((err) => console.log("PUT request error:", err));
      } else {
        fetch(pAPI_EMAIL_LOGS, {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            'groupId': gid, 'propertyId': pid, 'action': 'Generate Reply', 'content': lst, 'isEmailLogs': true
          }),
        })
          .then((res) => res.json())
          .then(async (result) => {
            console.log(result);
            setLogId(result?.data?.status ?? 0);

          });
      }
    }
  }



  const handleSummary = (text, systemInstructions, tools, url, lang, verbosity, additionalData, isFirstTime, from, to) => {
    let replyText = reply ?? "";
    let contentData = [];
    setReply("");
    fetch(url, {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        groupId: gid,
        propertyId: pid,
        language: lang,
        q: `Generate email reply body without subject. Use the same response as provided earlier by picking from history. Add: ${additionalData}. Generate email reply in ${lang} language`,
        suffix: "Generate email reply in " + lang + " language",
        conversationId: cid,
        propertyName: propertyDetails?.name,
        verbosity: verbosity,
        indexVersion: propertyDetails?.searchIndexVersion,
        index: propertyDetails?.searchIndexName,
        modelName: questionSetDetails?.openAiModel === "AzureGpt4" ? "gpt-4o-mini" : questionSetDetails?.openAiModel,
        history: [{ human: replyText !== "" ? replyText : text }],
        systemInstructions:
          "Today Date is : " +
          moment().format("LL") +
          " " +
          systemInstructions +
          "  " +
          "Response always need to come at " +
          lang +
          " language",
        tools: tools,
      }),
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result.arguments !== undefined) {
          let data = JSON.parse(result.arguments);
          let obj = "";
          if (result?.name === "rates_availability") {
            data.promoCode = threadResponse?.promo_code || threadResponse?.corporate_code || threadResponse?.group_code || "";
            setFunctionArguments(data);
            let checkInDate = data?.checkInDate;
            let checkOutDate = data?.checkOutDate;
            let group = data?.group;
            let location = data?.location;
            let responseFormat = data?.responseFormat;
            let promoCode = data?.promoCode || "";
            let bestRate = data?.bestRate || false;
            let availableAreas = data?.availableAreas || false;
            await axios(
              `${process.env.REACT_APP_API_URL}/find-by-property?propertyId=${pid}&groupId=${gid}&channel=''`,
              {
                method: "get",
              }
            ).then(async (response) => {
              // console.log(93, response);
              setPropertyIntegration(response.data);
              if (moment(data?.checkInDate).format("YYYY") < moment().format("YYYY"))
                checkInDate = moment().format("YYYY") + "-" + moment(data?.checkInDate).format("MM-DD");

              if (moment(data?.checkOutDate).format("YYYY") < moment().format("YYYY"))
                checkOutDate = moment().format("YYYY") + "-" + moment(data?.checkOutDate).format("MM-DD");

              let rmsPropertyId = '';
              if (response.data.Channel === 'Sabre') rmsPropertyId = pid;
              let availabilityurl = `${process.env.REACT_APP_PARTNER_URL}/public/availability/${response.data.Id}?propertyId=${rmsPropertyId}&children=${data?.numberOfChildren}&promoCode=${promoCode}&availableAreas=${availableAreas}&bestRate=false&exactMatch=false&ratePlanCode=&channel=${response.data.Channel}&rooms=1&group_id=${gid}&adults=${data?.numberOfAdults}&dateIn=${checkInDate}&dateOut=${checkOutDate}&discount=${0}`;

              await axios(availabilityurl, {
                method: "get",
              })
                .then(async (res) => {
                  const roomTypes = res.data.roomTypes;
                  // console.log(93,  res.data.roomTypes);
                  await axios(
                    `${process.env.REACT_APP_API_URL}/searchbookingengineurl?propertyId=${pid}&groupId=${gid}`,
                    {
                      method: "get",
                    }
                  ).then(async (engineRes) => {
                    // console.debug(engineRes);
                    const dateFormat = engineRes.data.result.dateFormat;
                    let bookingUrl = engineRes.data.result.bookingUrl;

                    bookingUrl = bookingUrl.replace("{CHECK_IN}", moment(checkInDate).format(dateFormat));
                    bookingUrl = bookingUrl.replace("{CHECK_OUT}", moment(checkOutDate).format(dateFormat));
                    bookingUrl = bookingUrl.replace("{ADULTS}", data?.numberOfAdults);
                    bookingUrl = bookingUrl.replace("{CHILDREN}", data?.numberOfChildren);
                    bookingUrl = bookingUrl.replace("{categoryGroup}", group);
                    bookingUrl = bookingUrl.replace("{location}", location);
                    bookingUrl = bookingUrl.replace("{LANGUAGE}", "en");
                    bookingUrl = bookingUrl.replace("{PromoCode}", promoCode);
                    // console.log(engineRes.data.result.bookingUrl,bookingUrl);

                    if (roomTypes !== undefined && roomTypes.length > 0) {
                      let isAvailable = false;
                      for (let i = 0; i < roomTypes.length; i++) {
                        if (roomTypes[i].available === true) {
                          isAvailable = true;
                          break;
                        }
                      }
                      if (isAvailable) {
                        let minRate = "0";
                        for (let i = 0; i < roomTypes.length; i++) {
                          if (roomTypes[i].available === true) {
                            if (responseFormat !== undefined && responseFormat !== null && responseFormat !== "") {
                              for (const [key, value] of Object.entries(roomTypes[i])) {
                                responseFormat = responseFormat.replaceAll("[" + key + "]", value.toString());
                                if (Object.entries(value) !== undefined) {
                                  for (const [keyValue, actualValue] of Object.entries(value)) {
                                    responseFormat = responseFormat.replaceAll(
                                      "[" + keyValue + "]",
                                      actualValue.toString()
                                    );
                                  }
                                }
                              }
                            }
                            //console.log(responseFormat, "responseFormat");
                            minRate = roomTypes[i].minimumRate?.price;
                            bookingUrl = bookingUrl.replace("{ROOM_TYPE}", roomTypes[i]?.roomTypeCode);
                            if (roomTypes[i]?.roomTypeCode !== "") {
                              const hashIndex = bookingUrl.indexOf("#");
                              if (hashIndex > bookingUrl.indexOf("?"))
                                bookingUrl =
                                  bookingUrl.slice(0, hashIndex) +
                                  "&roomtypeid=" +
                                  roomTypes[i]?.roomTypeCode +
                                  bookingUrl.slice(hashIndex);
                            }
                            if (roomTypes[i]?.minimumRate?.ratePlanId !== "") {
                              const hashIndex = bookingUrl.indexOf("#");
                              if (hashIndex > bookingUrl.indexOf("?"))
                                bookingUrl =
                                  bookingUrl.slice(0, hashIndex) +
                                  "&rateplanid=" +
                                  roomTypes[i]?.minimumRate?.ratePlanId +
                                  bookingUrl.slice(hashIndex);
                            }
                            break;
                          }
                        }
                        const result = {
                          success: "true",
                          min_rate: minRate,
                          type: "link",
                          url: bookingUrl,
                          caption: bookingUrl,
                        };
                        bookingUrl = bookingUrl.replace("C=&", `C=${data?.numberOfChildren}&`);
                        // await messageContext.UpdateChatGPTHistory({
                        //   human: "booking link",
                        //   ai: bookingUrl,
                        // });
                        if (responseFormat !== undefined && responseFormat !== null && responseFormat !== "") {
                          //console.log(197);
                          //  console.log(197, responseFormat);
                          responseFormat = responseFormat.replaceAll("[bookingLink]", bookingUrl.toString());
                          responseFormat = convertMarkdownLinksToHtml(responseFormat).replace(/\n/g, "<br />");
                          setReply(responseFormat);
                        } else {
                          fetch(url, {
                            method: "Post",
                            headers: {
                              Accept: "application/json",
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              groupId: gid,
                              propertyId: pid,
                              language: lang,
                              q: "",
                              suffix: "Response always need to come at " + lang + " language",
                              conversationId: cid,
                              propertyName: propertyDetails?.name,
                              modelName: questionSetDetails?.openAiModel === "AzureGpt4" ? "gpt-4o-mini" : questionSetDetails?.openAiModel,
                              verbosity: verbosity,
                              indexVersion: propertyDetails?.searchIndexVersion,
                              index: propertyDetails?.searchIndexName,
                              history: [
                                { human: text, ai: JSON.stringify(roomTypes) },
                                { human: "", ai: `<a href='${bookingUrl}' target='_blank'>Book Your Room</a>` },
                              ],
                              systemInstructions:
                                systemInstructions + "Response always need to come at " + lang + " language",
                              tools: tools,
                            }),
                          })
                            .then((res) => res.json())
                            .then(async (bookingRes) => {
                              if (bookingRes.arguments !== undefined) {
                                let bookingResData = JSON.parse(bookingRes.arguments);
                                if (isFirstTime)
                                  contentData.push({ 'user': text, 'bot': bookingResData?.response, from: from, to: to });
                                else
                                  contentData.push({ 'user': additionalInstructions, 'bot': bookingResData?.response, from: from, to: to });
                                handleManageStats(contentData);
                                if (bookingResData?.response) {
                                  obj = convertMarkdownLinksToHtml(bookingResData?.response).replace(/\n/g, "<br />");
                                  setReply(obj);
                                } else {
                                  setReply("<p>" + bookingResData?.response + "</p>");
                                }
                              }
                            });
                        }
                      } else {
                        setReply(
                          "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                        );
                        console.log(349, text, data?.response);
                        if (isFirstTime)
                          contentData.push({ 'user': text, 'bot': bookingResData?.response, from: from, to: to });
                        else
                          contentData.push({ 'user': additionalInstructions, 'bot': bookingResData?.response, from: from, to: to });
                        handleManageStats(contentData);
                      }
                    } else {
                      setReply(
                        "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                      );
                      if (isFirstTime)
                        contentData.push({ 'user': text, 'bot': bookingResData?.response, from: from, to: to });
                      else
                        contentData.push({ 'user': additionalInstructions, 'bot': bookingResData?.response, from: from, to: to });
                      handleManageStats(contentData);
                    }
                  });
                })
                .catch((error) => {
                  console.log(error);
                  setReply(
                    "Sorry... I'm not able to process the request right now. Can I help you with anything else?"
                  );
                });

              const diff = moment(moment(checkOutDate).format("YYYY-MM-DD")).diff(
                moment(checkInDate).format("YYYY-MM-DD"),
                "days"
              );
              await axios(`${process.env.REACT_APP_API_URL}/booking-engine-data`, {
                method: "post",
                data: {
                  groupId: gid,
                  propertyId: pid,
                  checkInDate: moment(checkInDate).format("YYYY-MM-DD"),
                  checkOutDate: moment(checkOutDate).format("YYYY-MM-DD"),
                  nights: diff,
                  adults: data?.numberOfAdults,
                  childrens: data?.numberOfChildren,
                  creator: "webview",
                  promoCode: "",
                },
              }).catch((error) => {
                console.log(error);
                setReply("Sorry... I'm not able to process the request right now. Can I help you with anything else?");
                if (isFirstTime)
                  contentData.push({ 'user': text, 'bot': bookingResData?.response, from: from, to: to });
                else
                  contentData.push({ 'user': additionalInstructions, 'bot': bookingResData?.response, from: from, to: to });
                handleManageStats(contentData);
              });
            });
          } else {
            await axios(
              `${process.env.REACT_APP_API_URL}/find-by-property?propertyId=${pid}&groupId=${gid}&channel=''`,
              {
                method: "get",
              }
            ).then(async (response) => {
              // console.log(93, response);
              setPropertyIntegration(response.data);
            });
            console.log(395, text, isFirstTime);
            if (isFirstTime)
              contentData.push({ 'user': text, 'bot': data?.response, from: from, to: to });
            else
              contentData.push({ 'user': additionalInstructions, 'bot': data?.response, from: from, to: to });
            console.log(395, contentData);
            handleManageStats(contentData);
            if (data?.response) {
              //  obj = data?.response.replace(/\n/g, "<br />");
              obj = convertMarkdownLinksToHtml(data?.response)
                .replace(/\n/g, "<br />");

              setReply(obj);
            } else {
              setReply("<p>" + data?.response + "</p>");
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleReload = (isFirstTime = false) => {
    Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, function (bodyTtext) {
      if (questionSetDetails !== undefined) {
        let systemTools = [];
        let toolsInstructions = "";
        if (questionSetDetails?.flowInvokeApi && questionSetDetails.flowInvokeApi?.isEnabled == true) {
          let tools = questionSetDetails.flowInvokeApi?.items;
          tools.map((obj) => {
            systemTools.push({
              type: "function",
              function: JSON.parse(obj.json),
            });
            toolsInstructions += obj?.instructions;
          });
        }
        setShowModal(false);
        handleSummary(
          (Office.context.mailbox?.initialData?.subject ?? "") + " " + bodyTtext["value"],
          questionSetDetails?.instructions,
          systemTools,
          questionSetDetails?.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_DYNAMIC_SUMMARY,
          lang,
          questionSetDetails.openAiVerbosity,
          additionalInstructions,
          isFirstTime,
          Office.context.mailbox?.initialData?.sender?.address + " " + Office.context.mailbox?.initialData?.sender?.name,
          Office.context.mailbox?.initialData?.to?.[0]?.address + " " + Office.context.mailbox?.initialData?.to?.[0]?.name
        );
      } else if (emailIntegration !== undefined) {
        let flow = result?.channelDetails && result?.channelDetails?.autonomousReplies;
        setShowModal(false);
        handleSummary(
          (Office.context.mailbox?.initialData?.subject ?? "") + " " + bodyTtext["value"],
          flow?.instructions,
          [],
          questionSetDetails?.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_SUMMARY,
          lang,
          questionSetDetails.openAiVerbosity,
          additionalInstructions,
          isFirstTime,
          Office.context.mailbox?.initialData?.sender?.address + " " + Office.context.mailbox?.initialData?.sender?.name,
          Office.context.mailbox?.initialData?.to?.[0]?.address + " " + Office.context.mailbox?.initialData?.to?.[0]?.name
        );
      }
    });
  };

  const handleReply = async () => {
    const popupWindow = await Office.context.mailbox.item.displayReplyFormAsync(reply);
    console.log(popupWindow);
    handleManage("updateStats", {
      pasteToOutlook: true,
      replyGenerated: mailStatsChange?.replyGenerated,
      copyDraft: mailStatsChange?.copyDraft,
    });
  };

  const handleChange = (source, content) => {
    if (source === "user") setReply(content);
  };

  const handleCopy = () =>
    handleManage("updateStats", {
      pasteToOutlook: mailStatsChange?.pasteToOutlook,
      replyGenerated: mailStatsChange?.replyGenerated,
      copyDraft: true,
    });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);
  const handleAdditionalInstructions = (e) => setAdditionalInstructions(e.target.value);

  const handleAppendContent = async (value) => {

    // if (source !== undefined) {

    //   let text = formatedText;

    //   const beforeText = text.substring(0, source - 1);

    //   const afterText = text.substring(source - 1, text.length - 1);

    //   console.log(436, beforeText, afterText, value);

    //   text = beforeText + "<br />" + "<table><tr><td>" + value + "</td></tr></table>" + afterText;

    //   console.log(438, text);

    //   setReply(text.replaceAll("\n", "<br />"));

    // }



    // await Office.context.mailbox.item.displayReplyFormAsync(

    //   reply + "<br /><br />" + "<table><tr><td>" + value + "</td></tr></table>"

    // );
    const ratesHtml = `<table><tr><td>${value}</td></tr></table>`;
    const signatures = [
      "Best regards,",
      "Warm regards,",
      "Kind regards,",
      "Regards,",
      "Sincerely,",
      "Thanks,",
      "Thank you,",
      "Warmly,",
      "Faithfully,",
      "Best wishes,",
      "Your's Sincerely,",
      "Your's Faithfully,",
      "Mahalo,",
    ];

    let updatedReply = reply;

    const searchStart = Math.max(0, reply.length - 500);
    const tail = reply.substring(searchStart);

    const signature = signatures.find(sig => tail.includes(sig));

    if (signature) {
      const index = reply.lastIndexOf(signature);

      updatedReply =
        reply.slice(0, index) +
        `${ratesHtml}<br><br>` +
        reply.slice(index);
    } else {
      updatedReply += `<br><br>${ratesHtml}`;
    }
    await Office.context.mailbox.item.displayReplyFormAsync(updatedReply);

  };
  // console.log('height', window.innerHeight, emailLang,  userLang, lang)
  return (
    <Fragment>
      <div className="page-content header-clear-small">
        <div className="row">
          <div className="col-2">
            <a href="#" onClick={() => handleManage("page", "main")} className="ml-3" style={{ float: "left", marginTop: "4px" }}>
              <span className="color-dark-dark">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                  />
                </svg>{" "}
              </span>
            </a>
          </div>
          <div className="col-10 text-right">
            {emailLang !== userLang && (
              <button
                type="submit"
                onClick={handleTranslation}
                style={{ textTransform: "none", padding: "5px 6px", fontSize: "13px" }}
                 className="btn-full btn button-myma-primary mr-2 translate_button"
              >
                   <span className="button-text">
                <IntlMessage id="main.translate_to" /> {Languages[lang === emailLang ? userLang : emailLang]}</span>
              </button>
             )} 
          </div>
        </div>

        <div
          className="card card-mobile-style mt-3"
          style={{
            borderRadius: "4px",
            height: `${window.innerHeight - (emailIntegration?.channelDetails?.showRoomsButton === true || emailIntegration?.channelDetails?.showRatesButton === true ? 100 : 150)}px`,
          }}
        >
          {reply === "" ? (
            <div className="sk-wrapper">
              <div className="sk-box">
                <div className="sk-line" />
                <div className="sk-line" />
                <div className="sk-line" />
                <div className="sk-line" />

                <div className="sk-gap" />

                <div className="sk-line l5" />
                <div className="sk-line l6" />
                <div className="sk-line l7" />
                <div className="sk-line l8" />
              </div>
            </div>
          ) : (
            <div className="col-12">
              <ReactQuill
                theme="snow"
                value={reply}
                // onFocus={(content, delta, source) => console.log(469, content, delta, source)}
                // onChangeSelection={(range, oldRange, source) => {
                //   if (range?.index > 0) {
                //     setSource(range?.index);
                //     setFormatedText(
                //       source
                //         .getHTML()
                //         .replaceAll("<p><br></p>", "\n")
                //         .replaceAll("<p>", "")
                //         .replaceAll("</p>", "")
                //         .replaceAll("<br />", "\n")
                //     );
                //   }
                // }}
                onChange={(content, delta, source) => handleChange(source, content)}
                style={{ height: `${window.innerHeight - 200}px` }}
                modules={quillModules}
                formats={quillFormats}
                name="ticketNotes"
              />
            </div>
          )}
          <div className="col-12 ">
            <div className="row" style={{ margin: "6px 10px" }}>
              <div className="col-6 text-center mb-2">
                  <button
                  type="button"
                  className="myma-ai-response-button"
                  onClick={() => openModal("div1")}
                  style={{    height: "30px", minHeight: "30px"}}
                >
                  <span className="myma-ai-sparkle-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 3v4" />
                      <path d="M7 5h4" />
                      <path d="M9 7l1.2 3.8L14 12l-3.8 1.2L9 17l-1.2-3.8L4 12l3.8-1.2L9 7z" />

                      <path d="M17 9v3" />
                      <path d="M15.5 10.5h3" />
                      <path d="M17 12l.8 2.2L20 15l-2.2.8L17 18l-.8-2.2L14 15l2.2-.8L17 12z" />
                    </svg>
                  </span>

                  <span className="myma-ai-response-text">
                <IntlMessage id="main.regenerate" />
                  </span>
                </button>
              </div>
              {/* <div className="col-6 text-center">
                    <CopyToClipboard text={reply.replaceAll("<br />", "\n")} onCopy={handleCopy}>
                      <button
                        type="submit"
                        className="btn-full btn border-green-dark reply-button"
                        style={{ padding: "6px" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          width={15}
                          height={15}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                          />
                        </svg>
                        <span className="ml-1" style={{ textTransform: "none" }}>
                          {" "}
                          Copy Draft
                        </span>
                      </button>
                    </CopyToClipboard>
                  </div> */}
              <div className="col-6 text-center">
                <button
                  type="submit"
                  onClick={handleReply}
                  className="btn-full btn border-green-dark reply-button"
                  style={{ padding: "6px" }}
                >
                  <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        width={15}
                        height={15}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                        />
                      </svg>
                  <span className="ml-1" style={{ textTransform: "none" }}>
                    <IntlMessage id="main.copy_text" />
                  </span>
                </button>
              </div>
              {emailIntegration?.channelDetails?.showRoomsButton === true && (
                <Rooms gid={gid} pid={pid} handleAppendContent={handleAppendContent}></Rooms>
              )}
              {/* {propertyIntegration && functionArguments && ( */}
              {emailIntegration?.channelDetails?.showRatesButton === true && (
                <Rates
                  gid={gid}
                  functionArguments={functionArguments}
                  propertyIntegration={propertyIntegration}
                  pid={pid}
                  handleAppendContent={handleAppendContent}
                ></Rates>
              )}
              {/* )} */}
            </div>
          </div>
          {/* Modal */}
          {showModal && (
            <div className="row additional-modal">
              <div className="modal-box">
                <div className="form-custom form-label mt-3">
                  <label className="color-theme form-label-active"><IntlMessage id="main.additional_instructions" /></label>
                  <textarea
                    placeholder="Make the email response more friendly and include detailed information."
                    name="textarea"
                    value={additionalInstructions}
                    onChange={handleAdditionalInstructions}
                    style={{ height: "300px" }}
                    className="form-control rounded-xs textarea-300"
                  />
                </div>
                <button
                  type="submit"
                  onClick={() => handleReload(false)}
                  className="btn-full btn border-green-dark reply-button"
                  style={{ padding: "6px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    width={15}
                    height={15}
                  >
                    <path d="M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182" />
                  </svg>
                  <span className="ml-1" style={{ textTransform: "none" }}>
                    <IntlMessage id="main.submit" />
                  </span>
                </button>
              </div>
              <button className="close-btn" onClick={closeModal}>
                &times;
              </button>
            </div>
          )}
        </div>
      </div>

    </Fragment>
  );
};

export default Reply;
